/**
 * Build the canonical Project URL `/p/:handle/:slug` from any shape that carries handle + slug.
 *
 * Phase 6: every link to a Project that has access to its author's handle and slug should route
 * via this helper. Legacy `/projects/:uuid` URLs still work (they soft-redirect to the canonical
 * form on load) but the frontend shouldn't *generate* them anymore — every fresh navigation
 * lands directly on the canonical URL so the address bar reflects it from the first paint.
 */
export const canonicalProjectUrl = (
  handle: string,
  slug: string,
  search?: string | URLSearchParams
): string => {
  const base = `/p/${encodeURIComponent(handle)}/${encodeURIComponent(slug)}`
  if (!search) return base
  const tail = typeof search === 'string' ? search : search.toString()
  if (!tail) return base
  return `${base}${tail.startsWith('?') ? tail : `?${tail}`}`
}
